import { useContext } from 'react'
import { UserLocationContext } from '~/providers/UserLocationProvider'

export const useUserLocation = () => {
  return useContext(UserLocationContext)
}
